/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Who can submit scores for a match
 * @export
 */
export const SubmitterType = {
    PARTICIPANT: 'PARTICIPANT',
    ADMIN: 'ADMIN',
    SYSTEM: 'SYSTEM'
} as const;
export type SubmitterType = typeof SubmitterType[keyof typeof SubmitterType];


export function instanceOfSubmitterType(value: any): boolean {
    for (const key in SubmitterType) {
        if (Object.prototype.hasOwnProperty.call(SubmitterType, key)) {
            if (SubmitterType[key as keyof typeof SubmitterType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubmitterTypeFromJSON(json: any): SubmitterType {
    return SubmitterTypeFromJSONTyped(json, false);
}

export function SubmitterTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitterType {
    return json as SubmitterType;
}

export function SubmitterTypeToJSON(value?: SubmitterType | null): any {
    return value as any;
}

export function SubmitterTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SubmitterType {
    return value as SubmitterType;
}

